import produce from "immer";

import types from "./types";

const INITIAL_STATE = {
  behavior: "create",
  components: {
    drawer: false,
    confirmDelete: false,
  },
  form: {
    filtering: false,
    disabled: true,
    saving: false,
  },
  colaboradores: [],
  servicos:[],
  colaborador: {
    nome: "",
    email: "",
    telefone: "",
    dataNacimento: "",
    sexo: "M",
    vinculo: "A",
    especialidade: [],
    contaBancaria:{
        titular:"",
        cpfCnpj:"",
        banco:"",
        tipo:"CC",
        agencia:"",
        numero:"",
        dv:""
    },

    
  },
  users:{
    id:"",
    name:"",
    email:"",
    cpf:"",
    phone_number:"",
    address:"",
    address_number:"",
    address_complement:"",
    address_district:"",
    address_city:"",
    address_state:"",
    address_zipcode:"",
    password:"",
    active:false
  },
  users_licenses:{
    id:"",
    photo:"",
    number:"",
    valid_to:"",
    category:"",
    users_id:"",
    active:""
  }
};

function colaborador(state = INITIAL_STATE, action) {
  switch (action.type) {
    case types.UPDATE_COLABORADOR: {
      return produce(state, (draft) => {
        draft = { ...draft, ...action.payload };
        return draft;
      });
    }
    case types.RESET_COLABORADOR: {
      return produce(state, (draft) => {
        draft.colaborador = INITIAL_STATE.colaborador;
        return draft;
      });
    }
   
    default:
      return state;
  }
}

export default colaborador;
